import { render, staticRenderFns } from "./ManageShopSettings.vue?vue&type=template&id=5b926f03&scoped=true&"
import script from "./ManageShopSettings.vue?vue&type=script&lang=js&"
export * from "./ManageShopSettings.vue?vue&type=script&lang=js&"
import style0 from "./ManageShopSettings.vue?vue&type=style&index=0&id=5b926f03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b926f03",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VCol,VDivider,VProgressCircular,VRow,VSnackbar})
